import { render, staticRenderFns } from "./Mutasi.vue?vue&type=template&id=153383b0"
import script from "./Mutasi.vue?vue&type=script&lang=js"
export * from "./Mutasi.vue?vue&type=script&lang=js"
import style0 from "./Mutasi.vue?vue&type=style&index=0&id=153383b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports